const SHARED_PROPERTIES = {
  property: 'onboarding',
};

const BANNER_CLICK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'banner',
  action: 'click',
};

const BANNER_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'banner',
  action: 'dismiss',
};

const BANNER_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'banner',
  action: 'view',
};

const HOTSPOT_CLICK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'hotspot',
  action: 'click',
};

const HOTSPOT_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'hotspot',
  action: 'dismiss',
};

const HOTSPOT_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'hotspot',
  action: 'view',
};

const MODAL_CLICK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'modal',
  action: 'click',
};

const MODAL_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'modal',
  action: 'dismiss',
};

const MODAL_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'modal',
  action: 'view',
};

const MULTISTEP_MODAL_CLICK_BACK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-modal',
  action: 'click-back',
};

const MULTISTEP_MODAL_CLICK_NEXT_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-modal',
  action: 'click-next',
};

const MULTISTEP_MODAL_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-modal',
  action: 'dismiss',
};

const MULTISTEP_MODAL_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-modal',
  action: 'view',
};

const MULTISTEP_TOOLTIP_CLICK_BACK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-tooltip',
  action: 'click-back',
};

const POPOVER_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'popover',
  action: 'dismiss',
};

const POPOVER_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'popover',
  action: 'view',
};

const MULTISTEP_POPOVER_CLICK_BACK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-popover',
  action: 'click-back',
};

const MULTISTEP_POPOVER_CLICK_NEXT_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-popover',
  action: 'click-next',
};

const MULTISTEP_POPOVER_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-popover',
  action: 'dismiss',
};

const MULTISTEP_POPOVER_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'multi-step-popover',
  action: 'view',
};

const TOOLTIP_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'tooltip',
  action: 'dismiss',
};

const TOOLTIP_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'tooltip',
  action: 'view',
};

const VALUE_PROPS_MODAL_CLICK_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'value-props-modal',
  action: 'click',
};

const VALUE_PROPS_MODAL_DISMISS_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'value-props-modal',
  action: 'dismiss',
};

const VALUE_PROPS_MODAL_VIEW_EVENT = {
  ...SHARED_PROPERTIES,
  category: 'value-props-modal',
  action: 'view',
};

export const Events = {
  bannerClick: BANNER_CLICK_EVENT,
  bannerDismiss: BANNER_DISMISS_EVENT,
  bannerView: BANNER_VIEW_EVENT,
  hotspotClick: HOTSPOT_CLICK_EVENT,
  hotspotDismiss: HOTSPOT_DISMISS_EVENT,
  hotspotView: HOTSPOT_VIEW_EVENT,
  modalClick: MODAL_CLICK_EVENT,
  modalDismiss: MODAL_DISMISS_EVENT,
  modalView: MODAL_VIEW_EVENT,
  multiStepModalClickBack: MULTISTEP_MODAL_CLICK_BACK_EVENT,
  multiStepModalClickNext: MULTISTEP_MODAL_CLICK_NEXT_EVENT,
  multiStepModalDismiss: MULTISTEP_MODAL_DISMISS_EVENT,
  multiStepModalView: MULTISTEP_MODAL_VIEW_EVENT,
  multiStepPopoverClickBack: MULTISTEP_POPOVER_CLICK_BACK_EVENT,
  multiStepPopoverClickNext: MULTISTEP_POPOVER_CLICK_NEXT_EVENT,
  multiStepPopoverDismiss: MULTISTEP_POPOVER_DISMISS_EVENT,
  multiStepPopoverView: MULTISTEP_POPOVER_VIEW_EVENT,
  multiStepTooltipClickBack: MULTISTEP_TOOLTIP_CLICK_BACK_EVENT,
  popoverDismiss: POPOVER_DISMISS_EVENT,
  popoverView: POPOVER_VIEW_EVENT,
  tooltipDismiss: TOOLTIP_DISMISS_EVENT,
  tooltipView: TOOLTIP_VIEW_EVENT,
  valuePropsModalClick: VALUE_PROPS_MODAL_CLICK_EVENT,
  valuePropsModalDismiss: VALUE_PROPS_MODAL_DISMISS_EVENT,
  valuePropsModalView: VALUE_PROPS_MODAL_VIEW_EVENT,
};
